<template lang="pug">
.div.tag-filter
  ul.tag-list
    tag-node(
      v-for="tag in tagTree",
      :key="tag.id",
      :tag="tag",
      :mode="mode",
      :states="states",
      @update="onUpdate"
    )
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import TagNode from "./TagNode.vue";

export default {
  name: "MediaTags",
  props: {
    mode: {
      type: String,
      default: "filter"
    }
  },
  components: {
    TagNode,
  },
  data() {
    return {
      states: {},
    };
  },
  computed: {
    ...mapGetters({
      tagTree: "media/tagTree",
    }),
  },
  methods: {
    ...mapActions({
      getTagTree: "media/getTagTree",
    }),
    onUpdate(states) {
      this.states = { ...states};
      this.$emit("change", this.states);
    },
    findTagById(id, list) {
      for (const t of list) {
        if (t.id === id) return t;
        const found = this.findTagById(id, t.children || []);
        if (found) return found;
      }
      return null;
    },
    tagClass(id) {
      const classes = ["neutral", "included", "excluded"];
      const c = this.states[id] || 0;
      return classes[c];
    },
  },
  created() {
    this.getTagTree();
  },
};
</script>

<style scoped lang="less">
.selector {
  width: 4vw;
  height: 4vw;
  border: 1px solid gray;
}
.included {
  background: green;
}
.excluded {
  background: red;
}
.tag-filter {
  margin: 2vw 0;
  background: #f8f8f8;
  padding:1vw 2vw;
  border: 1px solid gray;
  border-radius: 5px;
  box-shadow: 3px 3px 3px #777;
  ul.tag-list {
    list-style-type: none;
    display: block;
    padding: 0;
    margin: 0;

    li {
      margin: 2px 0;

      .tag-entry {
        display: flex;
        align-items: center;
        gap: 0.5em;

        .tag-name {
          flex: 1;
        }

        button {
          width: 1.5em;
          height: 1.5em;
          line-height: 1.2em;
          text-align: center;
          border: 1px solid #999;
          border-radius: 4px;
          cursor: pointer;
          font-weight: bold;

          &.included {
            background-color: #cfc;
            border-color: #090;
          }

          &.excluded {
            background-color: #fcc;
            border-color: #900;
          }
        }
      }
    }
  }
}
</style>
